<template>
	<div class="brandLanshuBox">
		<full-page :options="options" ref="fullpage">
			<div class="section pageBox1">
				<!-- 导航 -->
				<div class="navBar">
					<img class="navLogo" src="../assets/logo.png" alt="" @click="enterHome()">
					<ul class="navBarItem">
						<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
						<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
						<el-dropdown>
							<li><router-link to="/huaiBrand" exact tag="a">兰树品牌</router-link></li>
							<el-dropdown-menu class="elDropdown" slot="dropdown">
								<el-dropdown-item><router-link to="/huaiBrand"
										tag="a">淮树</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/shuiBrand"
										tag="a">水姻缘</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/yiBrand"
										tag="a">一清堂</router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span
											style="vertical-align: super;">+</span></router-link></el-dropdown-item>
								<el-dropdown-item><router-link to="/lanshuBrand"
										tag="a">兰树</router-link></el-dropdown-item>
										<el-dropdown-item><router-link to="/zbqfBrand"
											tag="a">植本清方</router-link></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
						<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
						<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
						
						<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>
						
						<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
					</ul>
				</div>
				<!-- 视频组件开始 -->
				<div class="busiz-mengban">
					<div class="login-container" v-show="isVideo" v-html="videoDetails">
					</div>
				</div>

			</div>
			<div class="section pageBox2">
				<div class="pageBoxOut2">
					<div class="headerTitle1">菩提节的诞生</div>
					<div class="headerTitle2">The birth of Bodhi</div>
					<!-- <div class="headerLine"></div> -->
					<div class="puTiJieBox">
						<img class="puTiJieBoxImg puTiJieBoxImg1" src="../assets/aboutLanshu/putiItemNew1.jpg" alt="">
						<img class="puTiJieBoxImg puTiJieBoxImg2" src="../assets/aboutLanshu/putiItemNew2.jpg" alt="">
						<img class="puTiJieBoxImg puTiJieBoxImg3" src="../assets/aboutLanshu/putiItemNew3.jpg" alt="">
					</div>
					<div class="puTiText">
						美容行业的从业人员肩负着发现美、传播美、分享美的使命。他们是美丽的使者，让更多的人变得美丽、自信、快乐。兰树为激发起美业人的自尊、自爱、自信，同时感恩他们对行业的热爱，对企业的敬畏，对顾客的尊重，因此设立了美业菩提节，这是为所有美容行业从业人员设立的专门节日。兰树企业于2016年成功举办了第一届美业菩提节，以后将每年举办一次。
					</div>
				</div>
			</div>
			<div class="section pageBox3">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="senseBox">
					<div class="senseBoxHeader">
						<img class="douIcon" src="../assets/brandLanshu/douIcon.png" alt="">
						<div class="iconTitle">菩提节的意义</div>
					</div>
					<div class="senseBoxText">
						传播美：为美业人搭建专业的培训及交流平台，致力于将美容师培养成美容医师，用专业的服务为更多消费者带去美好容颜。<br /><br />
						奉献爱：建立「菩提基金会」，以感恩之心回馈社会，助力公益事业，为社会带去更多温暖，让世界因我们而更美好。<br /><br />
						圆梦想：为美业人打造圆梦平台，提供发展机会，激发美业人的逐梦之心，和全体美业人一起逐梦未来。
					</div>
					<div class="senseBoxLine"></div>
					<div class="senseTitleBox">
						<div class="senseTitle1">兰树创始人</div>
						<!-- <div class="senseTitle2">钟鸣</div> -->
						<img class="signBox" src="../assets/brandLanshu/zhong_name.png" alt="">
					</div>
				</div>
			</div>

			<div class="section pageBox6">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="busiz-mengban">
					<div class="login-container" v-show="isVideo2" v-html="videoDetails2">
					</div>
				</div>
			</div>

			<div class="section pageBox4">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="pageBoxOut2">
					<div class="headerTitle1">菩提节的成就</div>
					<div class="headerTitle2">Achievements of Bodhi Festival</div>
					<!-- <div class="headerLine"></div> -->
					<div class="achievementBox">
						<div class="achievementBoxLeft">
							<div class="achievementBoxLeftitem1 achievementBoxLeftitem">
								<div class="achievementTitleBox">
									<div class="achievementTitle1">奉献爱</div>
									<div class="achievementTitle2">建立“菩提基金会”，捐助“大拇指工程”，让更多患病儿童获得救助，竖起大拇指。
										疫情期间，第一时间向湖北省红十字会捐款50万元。</div>

								</div>
								<div class="secondImgBox">
									<img class="secondImg" src="../assets/brandLanshu/second.png" alt="">
								</div>
							</div>
							<div class="achievementBoxLeftitem achievementBoxLeftitem2">
								<!-- <div class="achievementTitleBox">
									<div class="achievementTitle1">添加标题</div>
									<div class="achievementTitle2">设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考</div>
								</div>
								<div class="forthImgBox">
									<img class="forthImg" src="../assets/brandLanshu/fourth.png" alt="">
								</div>	 -->
							</div>
						</div>
						<div class="achievementBoxRight">
							<div class="achievementBoxRightitem achievementBoxRightitem1">
								<div class="firstImgBox">
									<img class="firstImg" src="../assets/brandLanshu/first.png" alt="">
								</div>

								<div class="achievementTitleBox achievementTitleBoxRight">
									<div class="achievementTitle1">传播美</div>
									<div class="achievementTitle2">用更好的产品，更专业的服务，为爱美人士带去健康美丽的肌肤。</div>
								</div>
							</div>
							<div class="achievementBoxRightitem achievementBoxRightitem2">
								<div class="thirdImgBox">
									<img class="thirdImg" src="../assets/brandLanshu/third.png" alt="">
								</div>
								<div class="achievementTitleBox achievementTitleBoxRight">
									<div class="achievementTitle1">圆梦想</div>
									<div class="achievementTitle2">开展“寻找圆梦人”活动，代理商打造圆梦平台，加盟商许愿，齐心协力，撸起袖子加油干，一起逐梦未来！
									</div>
								</div>
							</div>
							<div class="achievementBoxRightitem achievementBoxRightitem3">
								<!-- <div class="fifthImgBox">
									<img class="fifthImg" src="../assets/brandLanshu/fifth.png" alt="">
								</div>	
								<div class="achievementTitleBox achievementTitleBoxRight">
									<div class="achievementTitle1">圆梦想</div>
									<div class="achievementTitle2">开展“寻找圆梦人”活动，代理商打造圆梦平台，加盟商许愿，齐心协力，撸起袖子加油干，一起逐梦未来！</div>
								</div> -->
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="section pageBox5">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="pageBoxOut2">
					<div class="headerTitle1">菩提节 · 盛典</div>
					<div class="headerTitle2">BODHI FESTIVAL</div>
					<!-- <div class="headerLine"></div> -->
					<div class="previousBox">
						<el-carousel :interval="3000" type="card" height="400px" style="overflow: hidden;width:100%;"
							indicator-position="none">
							<el-carousel-item class="carsouseItem" v-for="(item, index) in puTiJIeData" :key="index">
								<div class="previousBoxLeft" @click="enterPuti(item.id, item.video_url)">
									<div class="previousBoxImgBox">
										<img class="previousBoxImg" :src="item.thumbnail_url" alt="">
									</div>
									<div class="previousTitleBox">
										<div class="previousTitle1 busiz-text-ellipes">{{ item.title }}</div>
										<div class="previousTitle2 busiz-text-ellipes">{{ item.description }}</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>


			<div class="section pageBox5">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="pageBoxOut2">
					<div class="headerTitle1">菩提节 · 风采</div>
					<div class="headerTitle2">BODHI FESTIVAL STYLE</div>
					<!-- <div class="headerLine"></div> -->
					<div class="styleBox">
						<div class="moreBox" @click="goMore" v-if="total > 6">
							<div class="more">更多</div>
							<div class="moreImg"><img src="../assets/Btn/next.png" alt=""></div>
						</div>


						<div class="secondBox">
							<div @click="enterMedia(item.id)" v-for="(item, index) in newsData" :key="index">
								<div class="focusItemBox">
									<div style="overflow:hidden;height: 200px;width: 100%;">
										<img style="width:100%; height:100%; object-fit: cover;" class="focusImg"
											:src="item.thumbnail_url" alt="">
									</div>
									<div class="maskBox">
										<div class="focusTitle busiz-text-ellipes">{{ item.title }}</div>
										<div class="focusTimeBox">
											<div class="focusTime">{{ item.create_time }}</div>
										</div>
										<div class="details">
											查看详情
										</div>
									</div>
								</div>

							</div>
						</div>


					</div>
				</div>
			</div>
			<div class="section pageBox4">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="pageBoxOut2">
					<!-- 底部 -->
					<div class="footerBox">
						<div class="footerBoxHeader">
							<div class="footerBoxHeaderLeft">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树公众号</span>
							</div>
							<div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
								<span class="codeText">兰树云小程序</span>
							</div>
							<!-- <div class="footerBoxHeaderRight">
			  		  				<img class="codeImg" src="../assets/code.png" alt="">
			  		  				<span class="codeText">兰树客服(QQ)</span>
			  		  			</div> -->

						</div>
						<div class="footerMainBox">
							<li class="footerShop"><a target="_blank"
									href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a>
							</li>
							<li class="footerShop"><a target="_blank"
									href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
							</li>
							<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a></li>
							<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
							<div class="lastHeader">
								<li><router-link to="/login" tag="a">登录</router-link></li>
								|
								<li><router-link to="/login" tag="a">注册</router-link></li>
							</div>
						</div>

						<div class="footerInfoBox">
							<div class="emailBox">邮箱: postermaster@lasur.com</div>
							<div class="phoneBox">电话: 0571-89025888</div>
							<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
						</div>



						<div class="footerLine"></div>
						<div class="footerBoxBottom">
							<div class="footerLeft">
								Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
									href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
								<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
									href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
									33052102000740号</a>
							</div>
						</div>

					</div>
				</div>
			</div>
		</full-page>
	</div>
</template>

<script>
import { myGet, myPost, login } from "@/api/http";
export default {
	name: 'complexTable',
	data() {
		return {
			options: {
				licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
				//是否显示导航，默认为false
				navigation: true,
			},
			activeIndex: 0,
			intnum: undefined,
			isBanner: true,// 是否显示banner图
			isVideo: false,// 是否显示视频
			isBanner2: true,// 是否显示banner图
			isVideo2: false,// 是否显示视频
			puTiJIeData: [
				// {
				// 	id:1,
				// 	img:require('../assets/brandLanshu/previousBoxImg1.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:2,
				// 	img:require('../assets/brandLanshu/previousBoxImg2.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:3,
				// 	img:require('../assets/brandLanshu/previousBoxImg1.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:4,
				// 	img:require('../assets/brandLanshu/previousBoxImg1.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// }
			],
			newsData: [],
			tableActive: 0,
			total: 0,
		}
	},
	computed: {
		left() {
			return -this.activeIndex * 100 + 'px'
		}
	},
	created() {
		console.log(111);
		this.gitSecurity();
		this.initVideo();
		this.initVideoSecond();
		this.gitSecurity2()
	},
	methods: {
		goMore() {
			this.$router.push('/lanshuTrends')
		},
		// 进入媒体详情页
		enterMedia(opaction) {
			let routeUrl = this.$router.resolve({ path: '/companyNewsDetail', query: { userId: opaction } });
			window.open(routeUrl.href, '_blank')
		},

		//获取兰树新闻
		gitSecurity2() {
			console.log('111', this.tableActive)
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: this.tableActive,
				pageNum: this.pageNum,
				pageSize: 6
			}).then((res) => {
				this.newsData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},

		scrollToTop() {
			fullpage_api.moveTo(1);

		},
		enterPuti(id, videoUrl) {
			let routeData = this.$router.resolve({ path: '/putiBrand', query: { userId: id, videoUrl: videoUrl } });
			window.open(routeData.href, '_blank');
		},
		enterHome() {
			this.$router.push({ path: '/' });
		},

		//获取兰树新闻
		gitSecurity() {
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: 3,
				pageNum: 1,
				pageSize: 12
			}).then((res) => {
				this.puTiJIeData = res.data.news_list;
				// console.log("asasd",this.puTiJIeData)
				this.total = res.data.total_num;
			});
		},

		// 视频
		initVideo() {
			this.videoDetails = `<video
				 							  id="onemyVideo"
				 							  class="video-js vjs-big-play-centered vjs-fluid"
				 							  
				 							  preload="auto"
				 							  width="100%"
				 							  height="100%"
				 							  poster=""
				 							>
				 								<source
			           type="application/x-mpegURL"
			           src="https://www.lasur.com/media/beauty/video/2020/12/10/strength2.m3u8"
			          >
				 							</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner = false;

				this.isVideo = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('onemyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: false,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					// width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					// height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});

		},
		initVideoSecond() {
			this.videoDetails2 = `<video
				 	 							  id="secondmyVideo"
				 	 							  class="video-js vjs-big-play-centered vjs-fluid"
				 	 							  controls
				 	 							  preload="auto"
				 	 							  width="100%"
				 	 							  height="100%"
				 	 							  poster="https://www.lasur.com/media/tinymce/2021/3/5/WechatIMG105.png"
				 	 							>
				 	 								<source
				            type="application/x-mpegURL"
				            src="https://www.lasur.com/media/beauty/video/2021/03/01/mengxiangdeliliang.m3u8"
				           >
				 	 							</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner2 = false;

				this.isVideo2 = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('secondmyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: false,
					//自动播放属性,muted:静音播放
					autoplay: false,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					//  width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					//  height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});

		}
	}
}
</script>

<style scoped>
.goTop {
	width: 2.6vw;
	height: 5.38vh;
	background: url(../assets/newLasur/goTop.png) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	overflow: hidden;
	position: absolute;
	right: 3.8vw;
	bottom: 9.25vh;
	cursor: pointer;
	z-index: 999;
}

.goTop:hover {
	background: url(../assets/newLasur/goTop2.png) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	overflow: hidden;
}

.brandLanshuBox {
	margin: 0;
	padding: 0;
}

.pageBoxOut2 {
	width: 90%;
	height: 100%;
	justify-content: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	box-sizing: border-box;
}



.pageBox1 {
	width: 100%;
	/* background: url(../assets/meiyeBdNew.jpg) no-repeat; */
	background-position: 50% 50%;
	background-color: #000000;
	background-size: 100%;
	overflow: hidden;
}

.pageBox2 {
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
}

.pageBox3 {
	width: 100%;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-31-49_89330.png) no-repeat;
	background-position: right 10%;
	background-size: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
}

.pageBox4 {
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #E8E8E8;
	overflow: hidden;
}

.pageBox6 {
	width: 100%;
	/* background: url(../assets/putizhige.png) no-repeat; */
	background-position: 50% 50%;
	background-size: 100%;
	background-color: #000000;
	overflow: hidden;
}

.pageBox5 {
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
}

.headerTitle1 {
	display: flex;
	font-size: 2.25em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 500;
	color: #000000;
	line-height: 50px;
	justify-content: center;
}

.headerTitle2 {
	display: flex;
	font-size: 1.125em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #111111;
	line-height: 25px;
	justify-content: center;
	margin-top: 0.5em;
}

.headerLine {
	display: flex;
	width: 36px;
	height: 3px;
	background: #ADADAD;
	margin: 0 auto;
	margin-top: 1em;
}

.puTiJieBox {
	width: 70%;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	margin: 0 auto;
	margin-top: 2%;
	box-sizing: border-box;
}

.puTiJieBox img:nth-child(1) {
	position: relative;
	left: -20rem;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.puTiJieBox img:nth-child(3) {
	position: relative;
	left: 20rem;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}


.pageBox2.active .puTiJieBox img:nth-child(3) {
	left: 0;
}

.pageBox2.active .puTiJieBox img:nth-child(1) {
	left: 0;
}

.puTiJieBoxImg {
	width: 25%;
	position: relative;
	transform: rotate(0deg);
	/* animation: puTiAnimate 2s;
		-webkit-animation: puTiAnimate 2s; */
}

.puTiJieBoxImg2 {
	width: 50% !important;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}

/* 动画效果 */
@keyframes puTiAnimate {
	from {
		opacity: 0;
		transform: rotate(90deg);
	}

	to {
		opacity: 1;
		transform: rotate(0deg);
	}
}

@-webkit-keyframes puTiAnimate {
	from {
		opacity: 0;
		transform: rotate(90deg);
	}

	to {
		opacity: 1;
		transform: rotate(0deg);
	}
}



.puTiText {
	width: 70%;
	position: relative;
	display: flex;
	margin: 0 auto;
	text-align: left;
	top: 20rem;
	font-size: 1em;
	text-indent: 2em;
	font-family: MicrosoftYaHei;
	color: #666666;
	opacity: 0;
	line-height: 25px;
	-moz-transition: 1s;
	-webkit-transition: 1s;
	/* animation: putitext 2s;
		-webkit-animation: putitext 2s; */
	box-sizing: border-box;
}

.pageBox2.active .puTiText {
	top: 1rem;
	opacity: 1;
}

/* 动画效果 */
@keyframes putitext {
	from {
		opacity: 0;
		top: 20em;
	}

	to {
		opacity: 1;
		top: 1em;
	}
}


@-webkit-keyframes putitext

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		top: 20em;
	}

	to {
		opacity: 1;
		top: 3em;
	}
}


.senseBox {
	display: flex;
	flex-direction: column;
}

.senseBoxHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 8%;
	margin-left: 8em;
	box-sizing: border-box;
}

.douIcon {
	width: 2%;
}


.iconTitle {
	font-size: 1.625em;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 35px;
	margin-left: 1em;
}

@keyframes puTiAnimate2 {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}



@-webkit-keyframes puTiAnimate2

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

.senseBoxText {
	width: 45%;
	display: flex;
	font-size: 1rem;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 25px;
	margin-left: 8em;
	margin-top: 2rem;
	opacity: 0.8;
	box-sizing: border-box;
	animation: puTiAnimate2 8s;
	-webkit-animation: puTiAnimate2 8s;
}

.senseBoxLine {
	width: 38.6%;
	height: 2px;
	background-color: #FFFFFF;
	opacity: 0.4;
	display: flex;
	margin-left: 8em;
	margin-top: 3rem;
}

.senseTitle1 {
	font-size: 1.125em;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 24px;
	display: flex;
}

/* 动画效果 */
@keyframes puTiAnimate1 {
	from {
		opacity: 0;
		width: 5%;
	}

	to {
		opacity: 1;
		width: 13%;
	}
}


@-webkit-keyframes puTiAnimate1 {
	from {
		opacity: 0;
		width: 5%;
	}

	to {
		opacity: 1;
		width: 13%;
	}
}



.signBox {
	width: 10%;
	position: relative;
	left: 10%;
	top: 15rem;
	opacity: 0;
	-moz-transition: 1s;
	-webkit-transition: 1s;
	/* animation: puTiAnimate1 3s;
		-webkit-animation: puTiAnimate1 3s; */
}

.pageBox3.active .signBox {
	top: 0;
	opacity: 1;
}


.senseTitle2 {
	font-size: 0.875em;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.5;
	display: flex;

}

.senseTitleBox {
	display: flex;
	flex-direction: column;
	margin-left: 8em;
	margin-top: 1rem;
}

.previousBox {
	width: 90%;
	/* display: flex;
		flex-direction: row;
		justify-content: space-around; */
	margin: 0 auto;
	margin-top: 2em;
}

.previousBoxLeft {
	width: 60%;
	display: flex;
	flex-direction: column;
	opacity: 0.5;

	position: relative;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	/* transform: rotate(0deg); */
	/* animation: putijie 5s;
		-webkit-animation: putijie 5s; */
	cursor: pointer;
}

.previousBoxImgBox {
	width: 100%;
}

.carsouseItem {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.pageBox5.active .previousBoxLeft {
	opacity: 1;
}

.previousBoxLeft:hover .previousTitle1 {
	color: #003F98;
}

.previousBoxLeft:hover .previousTitle2 {
	color: #003F98;
}


/* 动画效果 */
@keyframes putijie {
	from {
		opacity: 0;
		transform: rotate(120deg);
	}

	to {
		opacity: 1;
		transform: rotate(0deg);
	}
}

@-webkit-keyframes putijie {
	from {
		opacity: 0;
		left: 0%
	}

	to {
		opacity: 1;
		left: 6%
	}
}



.previousBoxRight {
	display: flex;
	flex-direction: column;
	width: 25%;
}

.previousBoxImg {
	width: 100%;
}


.previousTitleBox {
	display: flex;
	flex-direction: column;
	margin-top: 1em;
}


.previousTitle1 {
	width: 85%;
	font-size: 1.125em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #000000;
	line-height: 25px;
}


.previousTitle2 {
	width: 85%;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	margin-top: 1em;
}


/* footer */
.pageBox4 {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	background-color: #F8F9FB;
}

.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #F8F9FB;
	/* position:absolute;
	 	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
}


.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}


.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}


.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}


.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}



.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}


.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	padding-left: 2em;
	line-height: 28px;
}
/* 菩提成就 */
.achievementBoxRight {
	width: 50%;
	display: flex;
	flex-direction: column;
	/* margin-left: 2em; */
}

.achievementBoxLeft {
	width: 50%;
	display: flex;
	flex-direction: column;
}

.achievementBoxLeftitem {
	display: flex;
	flex-direction: row;
}

.achievementBoxRightitem {
	display: flex;
	flex-direction: row;
}

.achievementBoxLeftitem1 {
	position: relative;
	top: 1rem;
	left: -20rem;
	opacity: 0.5;
	-moz-transition: 2s;
	-webkit-transition: 2s;
	/* animation: achievementleft1 3s;
		-webkit-animation: achievementleft1 3s; */
}

.pageBox4.active .achievementBoxLeftitem1 {
	opacity: 1;
	left: 0rem;
}

/* 动画效果 */
@keyframes achievementleft1 {
	from {
		opacity: 0;
		left: -10rem
	}

	to {
		opacity: 1;
		left: 0;
	}
}

@-webkit-keyframes achievementleft1

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		left: -10rem;
	}

	to {
		opacity: 1;
		left: 0;
	}
}

.achievementBoxLeftitem2 {
	position: relative;
	top: 2rem;
	left: -20rem;
	opacity: 0.5;
	-moz-transition: 2s;
	-webkit-transition: 2s;
	/* animation: achievementleft1 3s;
		-webkit-animation: achievementleft1 3s;	 */
}


.pageBox4.active .achievementBoxLeftitem2 {
	opacity: 1;
	left: 0rem;
}

.achievementBoxRightitem2 {
	position: relative;
	top: 1rem;
	left: 20rem;
	opacity: 0.5;
	-moz-transition: 2s;
	-webkit-transition: 2s;
	/* animation: achievementright1 3s;
		-webkit-animation: achievementright1 3s; */
}

.pageBox4.active .achievementBoxRightitem2 {
	left: -2rem;
	opacity: 1;
}

.achievementBoxRightitem1 {
	position: relative;
	right: 0;
	-moz-transition: 2s;
	-webkit-transition: 2s;
	/* animation: achievementright1 3s;
		-webkit-animation: achievementright1 3s; */
}

/* 动画效果 */
@keyframes achievementright1 {
	from {
		opacity: 0;
		right: -10rem;
	}

	to {
		opacity: 1;
		right: 0;
	}
}

@-webkit-keyframes achievementright1

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		right: -10rem;
	}

	to {
		opacity: 1;
		right: 0;
	}
}

.achievementBoxRightitem3 {
	position: relative;
	top: 2rem;
	left: -3rem;
	animation: achievementright1 3s;
	-webkit-animation: achievementright1 3s;
	/* Safari 和 Chrome */
}




.achievementBox {
	width: 90%;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	margin-top: 5rem;
}



.achievementBoxHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
}




.achievementBoxMiddle {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding-right: 3em;
}



.achievementBoxBottom {
	display: flex;
	align-items: center;
	margin-left: 30em;
}



.achievementBoxBottomOuter {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
}



.achievementTitleBox {
	width: 65%;
	display: flex;
	flex-direction: column;
}


.achievementTitle1 {
	display: flex;
	font-size: 1.3em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	/* color: #003F98; */
	color: #222222;
	line-height: 25px;
}

.achievementTitle2 {
	display: flex;
	font-size: 1em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 25px;
	margin-top: 1rem;
}



.secondImg {
	width: 70%;
	margin-left: 2.5rem;
}

.forthImg {
	width: 70%;
	margin-left: 1em;
}

.fourthImg {
	width: 80%;
	position: relative;
	top: 5em;
	left: 4em;
}


.firstImg {
	width: 60%;
	margin-left: 1rem;
}

.thirdImg {
	width: 90%;
}



.fifthImg {
	width: 80%;
}

/* 导航 */

.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	z-index: 9999;
}



.router-link-active {
	border-bottom: 3px solid #FFFFFF;
}


.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}


.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	/* margin-right: 5em; */
}


.navBarItem li {
	list-style: none;
	/*padding: 1.56em 2.5em 1.56em 2.5em;*/
	float: left;
	/* margin-left: 2em; */
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #FFFFFF;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 0.8rem;
	padding-right: 0.8rem;
}


/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}


.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}


.el-icon-arrow-down {
	font-size: 12px;
}


.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.busiz-text-ellipes {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.el-carousel__item h3 {}

.el-carousel__item:nth-child(2n) {}

.el-carousel__item:nth-child(2n+1) {}


/* 视频组件 */
.busiz-mengban {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	z-index: 1;
}

.login-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	background-size: cover;
}

.busiz-video-box {
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 999;
	background-color: rgba(0, 0, 0, 0.3);
}


.styleBox {
	width: 80%;
	margin: 0 auto;
	margin-top: 2em;
}

.moreBox {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	cursor: pointer;
}

.more {
	height: 25px;
	font-family: Roboto;
	font-size: 20px;
	/* font-weight: bold; */
	line-height: 25px;
	text-align: center;
	letter-spacing: 0px;
	color: #2B3346;
	margin-right: 10px;
}

.moreImg {
	/* width: 14px; */
	height: 16px;
	-webkit-animation: 1s rowup linear infinite normal;
	animation: 1s rowup linear infinite normal;
}

.moreImg img {
	width: 100%;
	height: 100%;
}

@keyframes rowup {
	0% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}

	100% {
		-webkit-transform: translate3d(4px, 0, 0);
		transform: translate3d(4px, 0, 0);
	}
}





.focusItemBox {
	width: 22vw;
	margin-top: 2vh;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	align-items: center;
	transition: 0.3s ease;
	/* margin-top: 2em; */
	background-color: #FFFFFF;
	overflow: hidden;
	position: relative;
	border: 1px solid #D5D6DA;
}


.focusTitle {
	width: 90%;
	font-size: 1em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #000001;
	line-height: 28px;
	margin: 0 auto;
	margin-top: 1em;
}


/* .focusImg{
		width: 100%;
		height: 100%;
		margin-top: 1em;
	} */


.focusTimeBox {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	justify-items: flex-start;
	margin-top: 0.5em;
	margin-left: 1em;
}


.focusTime {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.45);
	line-height: 22px;
}

.details {
	width: 8em;
	margin: 0 auto;
	background: #0F3F93;
	border-radius: 6px;
	text-align: center;
	padding: 0.3em;
	color: #FFFFFF;
	position: relative;
	top: 10vh;
	transition: 0.6s ease;
}

.maskBox {
	width: 100%;
	height: 12vh;
	top: 0;
	position: relative;
	transition: 0.6s ease;
	background: #FFFFFF;
	/* background: #003F98; */
	overflow: hidden;

}


.focusItemBox:hover .details {
	top: 0.2vh;
	/* transition: 0.6s ease; */
}



.focusItemBox:hover .maskBox {
	top: -2em;
	transition: 0.6s ease;
}

.secondBox {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	/* justify-content: space-around;
	  width:100%;
	  margin: 0 auto;
	  padding-bottom: 5em;
	   */
}
</style>



// WEBPACK FOOTER //
// src/components/BrandLanshu.vue